module.exports = __webpack_public_path__ + "static/media/Edit.33176b25.svg";